import React from 'react'
import styled from 'styled-components'

const PrimaryButtonRemove = ({ text, iconLeft, iconRight, leftIconStyle, rightIconStyle, children, ...props }) => {
    return (
        <ButtonContainer {...props}>
            {iconLeft && <IconWrapper style={leftIconStyle}>{iconLeft}</IconWrapper>}
            {text ? text : children}
            {iconRight && <IconWrapper style={rightIconStyle}>{iconRight}</IconWrapper>}
        </ButtonContainer>
    )
}

export default PrimaryButtonRemove
const ButtonContainer = styled.button`
border-radius:4px;
display:flex;
align-items:center;
justify-content:center;
padding:7.5px 16px;
color:${({ theme }) => theme.menu.deleteColor};
background:${({ theme }) => theme.primaryButton.removeBackground};
border:1px solid ${({ theme }) => theme.menu.deleteColor};
gap:10px;
font-weight: 500;
font-size: 14px;
line-height: 100%;
letter-spacing: 0.04px;
cursor:pointer;
&:disabled{
opacity:0.4;
}
`
const IconWrapper = styled.span`
    display: flex;
    align-items: center;
`